export function addClientSpecificFunctions (catalogName) {
  try {
    const { customFunctions } = require(`./${catalogName}.js`)
    customFunctions()
  } catch (e) {
    // NO CUSTOM JS FUNCTIONS FOR THIS CATALOG
  }
}
